import moment from "moment";
import React, { useEffect, useState } from "react";
import { BackButton, TableData } from "../../components";
import { errorAlert } from "../../helpers/alerts";
import { useNavigate } from "react-router-dom";
import { getYesterdayConcilliations } from "services/admin/conciliacionService";
import { sortArrayBy } from "helpers/util";

const PanelConciliacionScreen = ({ slim }) => {
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const shortList = new Array(15).fill({});

  useEffect(() => {
    setLoading(true)
    getYesterdayConcilliations().then((response) => {
      setList(sortArrayBy(response, item => item.cred.name_connector));
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {!slim && <BackButton name={'Regresar'} click={() => navigate(-1)} />}
      <TableData
        title={"Conciliación"}
        onTitleClick={() => slim && navigate('../admin/proveedores/conciliaciones')}
        rowsPerPageOpt={50}
        autonumber={false}
        pagination={false}
        loading={loading}
        headerStyle={slim && {
          fontSize: slim ? 10 : 12,
        }}
        dataRows={(slim ? shortList.map((item, i) => list[i] || {}) : list).map((item) => ({
          ...item,
          style: {
            fontSize: slim ? 11 : 12,
          }
        }))}
        dataTitle={[
          "Fecha",
          "Instancia",
          "Estatus",
        ]}
        formatter={({
          cred,
          status,
          createdAt
        }) => ([
          createdAt ? moment(createdAt).format('DD/MM/YY') : '-',
          cred?.name_connector ? {
            type: 'text',
            value: cred?.name_connector,
            maxWidth: 100
          } : '-',
          status ? {
            type: 'text',
            value: status,
            maxWidth: 100
          } : '-',
        ])}
      />
    </>
  );
};

export default PanelConciliacionScreen;
